import ForgotMain from '@/components/RegAndForgot/ForgotMain';
const Forget = () => {
    const element = (<><ForgotMain /></>);
    return element
}

export default Forget